import template from "./entity-business-products.html";
import "./entity-business-products.less";

import {
	ENTITY_TRANSLATION_KEYS, 
	I18NextContext 
} from "../../../../../../../services/i18nService";
import { FORM_BUSINESS_PRODUCTS } from "../../../../../../../routes";
import { globs } from "../../../../../../../services/globs";

// type ProfileFeeDto = { Code:string }
// type Product = {
//    Code: string; //server managed
//    Name: string;
//    Price: decimal;
//    IsActive: boolean;
//	  IsInvoiceDefault: boolean;
//    Fees: ProfileFeeDto[]; //only the Code!
// }

export function controller($logger, api, loadingService, $uibModal, $scope, securityService, appState) {
	const ctrl = this;

	ctrl.i18n = I18NextContext.Instance;
	ctrl.ENTITY_TRANSLATION_KEYS = ENTITY_TRANSLATION_KEYS;

	ctrl.$onInit = () => {
		ctrl.canReadBusinessProductsGlob = globs.business.byType("*").products.byType("*").read;
		ctrl.canUpdateBusinessProductGlob = globs.business.byType("*").products.byType("*").update;
		ctrl.canCreateBusinessProductGlob = globs.business.byType("*").products.byType("*").create;
				
		$scope.$watch(() => ctrl.businessId, loadProducts);
	};

	ctrl.editProduct = async(product) => {
		const update = await $uibModal.open({
			component: "entity-business-product-modal",
			size: "smmd",
			backdrop: "static",
			resolve: {
				product: () => product,
				charges: () => ([ ...ctrl.availableCharges ]),
				save: () => saveProduct
			}
		}).result;

		const matchindex = ctrl.products.findIndex(c => c.Code === update.Code);
		if(matchindex !== -1) {
			ctrl.products[matchindex] = update;
		}
		else {
			ctrl.products.push(update);
		}	

		return update;
	};

	async function saveProduct(product) {
		const verb = product.Code !== undefined ? "put" : "post";
		const saveBusiness = ctrl[verb](FORM_BUSINESS_PRODUCTS(appState.forms.selected.Id, ctrl.businessId), product);
		const resp = await loadingService.watch(saveBusiness);

		return resp;
	}

	async function loadProducts() {
		const canReadProducts = securityService.isPatternAllowed(ctrl.canReadBusinessProductsGlob);
		if(ctrl.businessId === undefined || !canReadProducts) {
			ctrl.products = [];
			return;
		}
		const getProducts = api.get(FORM_BUSINESS_PRODUCTS(appState.forms.selected.Id, ctrl.businessId));
		
		const products = await loadingService.watch(getProducts);
		ctrl.products = products.filter(c => c.IsActive);
	}
}

export default angular.module("vesl.components.entity-business-products", [])
	.component("entityBusinessProducts", {
		controller,
		template,
		bindings: {
			businessId: "<",
			availableCharges: "=",
			put: "=",
			post: "="
		}
	})
	.name;
